<template>
    <div v-if="billingAddress">
        <p v-html="getFormattedAddress"></p>
        <!-- <multiselect
            class="w-full sm:w-2/3 mx-auto"
            v-model="selectedAddress"
            track-by="summary_string"
            label="address1"
            placeholder="Please select address"
            :allow-empty="false"
            :options="availableAddresses">
        </multiselect> -->

        <p class="error sm:w-2/3 mx-auto" v-text="error"></p>

        <p class="pb-2" v-if="showBillingAddressForm === false">
            <a class="link" @click.prevent="toggleEditBillingForm" v-text="$t('MANAGE_BILLING_ADDRESS_EDIT')"></a>
        </p>

        <div :class="editBillingAddressAccordionClass" class="w-full sm:w-2/3 mx-auto">
            <edit-billing-address-form
                v-if="billingAddress !== null"
                :key="showBillingAddressForm"
                :address="billingAddress"
                @closed="toggleEditBillingForm">
            </edit-billing-address-form>
        </div>
    </div>
</template>

<script>
// import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import { getFormattedAddressForCountry } from '@/helpers/AddressHelpers';
import PaymentService from '@/services/payments/PaymentService';
import EditBillingAddressForm from '@/components/forms/addresses/EditBillingAddressForm';

export default {
    name: 'ManageBillingAddress',
    data() {
        return {
            availableAddresses: [],
            showBillingAddressForm: false,
            selectedAddress: null,
            error: null,
        };
    },
    methods: {
        populateAvailableAddresses() {
            this.selectedAddress = this.billingAddress;

            this.availableAddresses.push(this.selectedAddress);
            for (let addId in this.allAddresses) {
                const address = this.allAddresses[addId];
                const summary = address?.summary_string;

                // Determine whether the address is already in the addresses collection ensuring its unique
                let alreadyExists = this.availableAddresses.filter(item => {
                    return item.summary_string === summary;
                }).length > 0;

                if (alreadyExists === false) this.availableAddresses.push((address));
            }
        },

        switchBillingAddress(address) {
            let paymentService = new PaymentService();
            const newAddress = {
                firstName: address.first_name,
                lastName: address.last_name,
                houseNumber: address.houseNumber,
                address1: address.address1,
                address2: address.address2,
                city: address.city,
                country: address.country,
                postcode: address.postcode,
            };

            paymentService
                .updateBillingAddress(this.userId, this.billingAddress.id, newAddress)
                .then(() => {
                    this.$scrollTo('#manageBllingContainer');
                    this.$store.dispatch('address/fetchAllAddresses', true);
                })
                .catch(() => {
                    this.error = this.$t('MANAGE_BILLING_ADDRESS_SORRY');
                });
        },

        toggleEditBillingForm() {
            this.showBillingAddressForm = !this.showBillingAddressForm;

            if (this.showBillingAddressForm === true) this.$scrollTo('#billingAddressForm');
        },
    },
    computed: {
        ...mapGetters({
            fullName: 'account/getFullName',
            allAddresses: 'address/getAddresses',
            billingAddress: 'address/getBillingAddress',
            userId: 'account/getUserId',
        }),
        expandFormName: {
            get() {
                return this.$store.getters['account/getExpandFormName'];
            },
            set(value) {
                this.$store.commit('account/updateExpandFormName', value);
            },
        },
        editBillingAddressAccordionClass() {
            return this.showBillingAddressForm ? 'accordion__md accordion__md--active' : 'accordion__md';
        },

        getFormattedAddress() {
            return getFormattedAddressForCountry(this.billingAddress, this.fullName);
        },

    },
    watch: {
        selectedAddress(newAddress) {
            if (this.billingAddress.id !== newAddress.id) this.switchBillingAddress(newAddress);
        },
        billingAddress(address) {
            if (address !== null) this.populateAvailableAddresses();
        },
    },
    components: {
        EditBillingAddressForm,
        // Multiselect,
    },
};
</script>
